export default "__VITE_ASSET__Dg9aoF86__"